import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { faqQueries } from '@/services/faq/faq.queries';
import { useSearch } from '@tanstack/react-router';

export const useReviewAndRatings = () => {
  const { page, sort, fetch, q, ratingsFilter } = useSearch({ from: '/(app)/faq/review-ratings/' });
  const { data, isLoading } = useQuery({
    ...faqQueries.reviewAndRatings({ fetch: fetch, row: page, search: q ?? '', ratingsFilter: ratingsFilter }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return { reviews: data?.data || [], pagination: data?.meta?.pagination ?? defaultMeta, loading: isLoading };
};
